/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

export interface Device {
    id: string;
    volumeId: string;
    jackSenseId: string;
    muteId?: string;
    name: string;
    abbreviation: string
    direction: 'input' | 'output';
    agc: boolean;
    volume: number;
    boost: -6 | 0 | 6 | 12; //boost in dB
    threshold: number;
    connected: boolean;
}

export interface InputDevice extends Device {
    direction: 'input';
    muted: boolean;
    muteOnAnswer: boolean;
}

export interface OutputDevice extends Device {
    direction: 'output';
}

export interface CCHubDevice extends MediaDeviceInfo {
    peripheral: string;
    channel: number;
}

export class MediaTools {
    public static ccHubMediaDeviceInfo(mediaDevice: MediaDeviceInfo, name: string, channel: number) {
        const result = mediaDevice as CCHubDevice;
        result.channel = channel;
        result.peripheral = name;
        return result;
    }
}
